import { render } from "./LightBulbIcon.vue?vue&type=template&id=9507f12a"
const script = {}
script.render = render

export default script